import { render } from "./ExchangeDialog.vue?vue&type=template&id=dbe41a4c&scoped=true"
import script from "./ExchangeDialog.vue?vue&type=script&lang=js"
export * from "./ExchangeDialog.vue?vue&type=script&lang=js"

import "./ExchangeDialog.vue?vue&type=style&index=0&id=dbe41a4c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbe41a4c"]])

export default __exports__